
import type {
  AddIntegrationReq,
  AddIntegrationRes,
  BaseErrorResponse,
  EmptySuccessResponse,
  GetIntegrationsRes,
  UpdateIntegrationReq,
} from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function useIntegration() {
  class Integration<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Integration
     * @name IntegrationControllerAddIntegration
     * @summary Adds a new integration
     * @request POST:/api3/integration
     * @secure
     * @response `200` `AddIntegrationRes`
     * @response `400` `BaseErrorResponse`
     */
    integrationControllerAddIntegration = (data: AddIntegrationReq, params: RequestParams = {}) =>
      this.request<AddIntegrationRes, BaseErrorResponse>({
        path: '/api3/integration',
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Integration
     * @name IntegrationControllerGetList
     * @summary Returns a list of integrations
     * @request GET:/api3/integration
     * @secure
     * @response `200` `GetIntegrationsRes`
     * @response `400` `BaseErrorResponse`
     */
    integrationControllerGetList = (params: RequestParams = {}) =>
      this.request<GetIntegrationsRes, BaseErrorResponse>({
        path: '/api3/integration',
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Integration
     * @name IntegrationControllerUpdateIntegration
     * @summary Updates an integration
     * @request PUT:/api3/integration/{id}
     * @secure
     * @response `200` `AddIntegrationRes`
     * @response `400` `BaseErrorResponse`
     */
    integrationControllerUpdateIntegration = (id: string, data: UpdateIntegrationReq, params: RequestParams = {}) =>
      this.request<AddIntegrationRes, BaseErrorResponse>({
        path: `/api3/integration/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Integration
     * @name IntegrationControllerDeleteIntegration
     * @summary Deletes an integration
     * @request DELETE:/api3/integration/{id}
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    integrationControllerDeleteIntegration = (id: string, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: `/api3/integration/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Integration
     * @name IntegrationControllerRegenerateSecretKey
     * @summary Updates an integration secret key
     * @request PUT:/api3/integration/{id}/secret-key
     * @secure
     * @response `200` `AddIntegrationRes`
     * @response `400` `BaseErrorResponse`
     */
    integrationControllerRegenerateSecretKey = (id: string, params: RequestParams = {}) =>
      this.request<AddIntegrationRes, BaseErrorResponse>({
        path: `/api3/integration/${id}/secret-key`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new Integration();
}
